import { render, staticRenderFns } from "./GeneralInformationForm.vue?vue&type=template&id=71607a94&scoped=true"
import script from "./GeneralInformationForm.vue?vue&type=script&lang=js"
export * from "./GeneralInformationForm.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformationForm.vue?vue&type=style&index=0&id=71607a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71607a94",
  null
  
)

export default component.exports